import type { EventRecord } from '@vlabs/api/artemy/model';

import { useWorkspaceEventContext } from './WorkspaceEventContext';

type SelectedWorkspaceEvent = EventRecord;

interface UseSelectedWorkspaceEventReturn {
  event: SelectedWorkspaceEvent | null;

  selectedEventId: string | null;

  isEvent: boolean;
  isGeneralEvent: boolean;

  setSelectedEvent: (event: SelectedWorkspaceEvent) => void;
  clearSelectedEvent: () => void;
}

export function useSelectedWorkspaceEvent(): UseSelectedWorkspaceEventReturn {
  const {
    event,
    setEvent,
    clearEvent,
  } = useWorkspaceEventContext();

  const isGeneralEvent = false;
  const isEvent = !!event && !isGeneralEvent;

  const selectedEventId = event?.event_id ?? null;

  return {
    event,
    selectedEventId,
    isEvent,
    isGeneralEvent,
    setSelectedEvent: setEvent,
    clearSelectedEvent: clearEvent,
  };
}
